import styled from '@emotion/styled';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { Message, Paragraph, Link, colors } from 'component-library/index';

const StyledLink = styled(Link)`
  color: ${colors.base.black};
`;

export const NoValidCostCenter = () => {
  return (
    <Message
      severity="error"
      title={t('co2_impact.checkout.errors.no.valid.cost.center.in.hierarchy.title')}
    >
      <Paragraph variant={'large'}>
        <Trans
          components={{
            ContactLink: <StyledLink href="/support/contact" inline underline />,
          }}
          i18nKey={'co2_impact.checkout.errors.no.valid.cost.center.in.hierarchy.description'}
        />
      </Paragraph>
    </Message>
  );
};
